// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"common-sidebar_sidebar_3jWr-","link":"common-sidebar_link_chalL","section":"common-sidebar_section_6XVMg"};